// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".deep-analysis .report-element {\n  scroll-margin-top: 64px;\n}\n.deep-analysis .report-element:target {\n  padding-top: 16px;\n  margin-top: 0;\n  z-index: 1;\n}\n", ""]);
// Exports
module.exports = exports;
